export { CRMContactDataService } from './crm-contact-data.service'
export { CRMContactConnector } from './crm-contact.connector'